import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

import { getRem, transitionAnimation, typographyBody1, typographyBody2 } from "../../core";
import styled, { css } from 'styled-components';
import { INPUT_SIZES } from "../constants";
var sizeStyles = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var size = _ref.size,
      theme = _ref.theme;
  return size === INPUT_SIZES.LARGE ? css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n          ", ";\n          height: ", ";\n        "])), typographyBody2(theme), getRem(24)) : css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n          height: ", ";\n        "])), getRem(20));
});
var BaseInputField = styled.input.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['hasError', 'hideBorder', 'inputDivider', 'isObscured', 'size'].includes(prop);
  }
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  background: transparent;\n  border: none;\n  box-shadow: none;\n  box-sizing: border-box;\n  min-width: 0;\n  outline: none;\n  padding: 0;\n  padding-right: ", ";\n  width: 100%;\n\n  ", "\n\n  &::placeholder {\n    color: ", ";\n    font-weight: ", ";\n  }\n\n  &::-ms-clear,\n  &::-ms-reveal {\n    display: none;\n  }\n  /* Direct selection necessary to apply styling for all other possible password input cases */\n  &[type='password']:not([value='']) {\n    font-family: ", ";\n  }\n  ", "\n"])), transitionAnimation('border, box-shadow'), function (_ref2) {
  var theme = _ref2.theme;
  return typographyBody1(theme);
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.size.spacing.small.value;
}, sizeStyles, function (_ref4) {
  var theme = _ref4.theme;
  return theme.color.gray[600].value;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.font.weight.light.value;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.font.family.obscured.value;
}, function (_ref7) {
  var isObscured = _ref7.isObscured,
      theme = _ref7.theme;
  return isObscured && css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n      font-family: ", ";\n    "])), theme.font.family.obscured.value);
});
export { BaseInputField };